export default "__VITE_ASSET__Dbu5vBO___"